import { useState, useRef, useEffect } from 'react';
import classes from './Layout.module.css';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import Navigation from '../../components/Navigation/Navigation';
import { Container } from 'react-floating-action-button';
import { whatsAppIcon, callIcon } from '../../shared/fontAwesomeIcons/fontAwesomeIcons';
import { urlConstants } from '../../constants/UrlConstants';

const Layout = (props) => {

    const scrollElement = document.scrollingElement || document.documentElement;
    function scrollToTop() {
        scrollElement.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    }

    const [showPopup, setShowPopup] = useState(null);
    const whatsappAreaRef = useRef(null);
    const phoneAreaRef = useRef(null);

    
    const handleWhatsAppClick = (e) => {
        e.stopPropagation();
        setShowPopup(prev => (prev === 'whatsapp' ? null : 'whatsapp'));
    };

    const handlePhoneClick = () => {
        setShowPopup(prev => (prev === 'phone' ? null : 'phone'));
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
        const clickedOutsideWhatsApp =
            whatsappAreaRef.current && !whatsappAreaRef.current.contains(event.target);
        const clickedOutsidePhone =
            phoneAreaRef.current && !phoneAreaRef.current.contains(event.target);

        if (showPopup === 'whatsapp' && clickedOutsideWhatsApp) {
            setShowPopup(null);
        } else if (showPopup === 'phone' && clickedOutsidePhone) {
            setShowPopup(null);
        }

        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [showPopup]);

    return (
        <div className={classes.layoutContainer}>
            <Header className={classes.layoutContainer__header} />
            <Navigation className={classes.layoutContainer__navigation} />
            <main className={classes.layoutContainer__mainContent}>
                {props.children}
            </main>
            <Footer clickHandler={scrollToTop} />
            <Container>
            <div className={classes.fabWrapper} ref={whatsappAreaRef}>
                <button className={classes.whatsappButton} onClick={handleWhatsAppClick}> 
                    <span>{whatsAppIcon}</span> 
                </button>

                {showPopup === "whatsapp" && (
                    <div className={classes.popupContainer}>
                        <div className={classes.popupButton}>
                            <a href={urlConstants.VELACHERY_WHATSAPP_URL} 
                            target="_blank" rel="noreferrer nofollow">
                                💬 Chat with Velachery Store
                            </a>
                        </div>
                        <div className={classes.popupButton}>
                            <a href={urlConstants.ANNA_NAGAR_WHATSAPP_URL} 
                            target="_blank" rel="noreferrer nofollow">
                                💬 Chat with Anna Nagar Store
                            </a>
                        </div>
                    </div>
                )}
            </div>
            </Container>
            <Container>
                <div className={classes.fabWrapper} ref={phoneAreaRef}>
                <button className={classes.phoneButton} onClick={handlePhoneClick}> 
                    <span>{callIcon}</span> 
                </button>

                {showPopup === "phone" && (
                    <div className={classes.popupContainer}>
                        <div className={classes.popupButton}>
                            <a href={urlConstants.VELACHERY_PHONE_NUMBER} 
                            target="_blank" rel="noreferrer nofollow">
                                📞 Call Velachery Store
                            </a>
                        </div>
                        <div className={classes.popupButton}>
                            <a href={urlConstants.ANNA_NAGAR_PHONE_NUMBER} 
                            target="_blank" rel="noreferrer nofollow">
                               📞 Call Anna Nagar Store
                            </a>
                        </div>
                    </div>
                )}
            </div>
            </Container>
        </div>
    );
};

export default Layout;